import { render, staticRenderFns } from "./SubjectDetail5.vue?vue&type=template&id=016d1104&scoped=true&"
import script from "./SubjectDetail5.vue?vue&type=script&lang=js&"
export * from "./SubjectDetail5.vue?vue&type=script&lang=js&"
import style0 from "./SubjectDetail5.vue?vue&type=style&index=0&id=016d1104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016d1104",
  null
  
)

export default component.exports